
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import IndividualOrganisationSummary from './IndividualOrganisationSummary'

type Props = {
}


function OrganisationOverview({
}: Props) {

    const { tableData } = useContext(GlobalContext)


    return <div className={`w-full flex flex-col items-center justify-center gap-4`}>

            <h3 className={`text-2xl font-brandblue font-righteous`}>Organisations overview</h3>

            {Object.keys(tableData.Organisations).map((organisationId, index) => {
                return <IndividualOrganisationSummary
                    key={index}
                    organisationId={organisationId}
                    organisation={tableData.Organisations[organisationId]}
                />
            })}

        </div>
}

export default OrganisationOverview